var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlutterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 44,
    viewBox: "0 0 154 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9346 9.12305H67.5874V11.9923H55.9153V20.6559H66.4453V23.4973H55.9153V34.473H52.9346V9.12305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1252 9.12305H74.1338V34.4452H71.1252V9.12305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1791 33.1083C79.0369 31.8269 78.4519 30.044 78.4519 27.7598V16.394H81.4605V27.2862C81.4605 29.0133 81.8505 30.2669 82.6305 31.0748C83.4105 31.8826 84.4691 32.2726 85.7783 32.2726C86.7812 32.2726 87.7005 31.994 88.4805 31.4648C89.2605 30.9355 89.8733 30.2112 90.319 29.3476C90.7648 28.484 90.9598 27.5648 90.9598 26.5898V16.394H93.9962V34.4455H91.1269V31.8269H90.9876C90.4862 32.7183 89.7062 33.4705 88.6198 34.0833C87.5333 34.6962 86.3912 35.0026 85.1655 35.0026C82.9648 35.0305 81.3212 34.3898 80.1791 33.1083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.523 34.668C102.91 34.4173 102.381 34.1109 101.935 33.693C101.462 33.2473 101.1 32.718 100.877 32.1052C100.654 31.4923 100.515 30.768 100.515 29.9045V19.1238H97.3667V16.3938H100.515V11.2959H103.523V16.3938H107.925V19.1238H103.551V29.1802C103.551 30.183 103.746 30.9352 104.108 31.4088C104.554 31.938 105.195 32.2166 106.058 32.2166C106.755 32.2166 107.395 32.0216 108.036 31.6038V34.5288C107.674 34.6959 107.312 34.8073 106.95 34.8909C106.587 34.9745 106.114 35.0023 105.557 35.0023C104.832 35.0302 104.136 34.8909 103.523 34.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.282 34.668C115.669 34.4173 115.14 34.1109 114.694 33.693C114.22 33.2473 113.858 32.718 113.635 32.1052C113.412 31.4923 113.273 30.768 113.273 29.9045V19.1238H110.153V16.3938H113.301V11.2959H116.31V16.3938H120.683V19.1238H116.31V29.1802C116.31 30.183 116.505 30.9352 116.867 31.4088C117.312 31.938 117.953 32.2166 118.817 32.2166C119.513 32.2166 120.154 32.0216 120.794 31.6038V34.5288C120.432 34.6959 120.07 34.8073 119.708 34.8909C119.346 34.9745 118.872 35.0023 118.315 35.0023C117.591 35.0302 116.922 34.8909 116.282 34.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.951 33.7769C125.586 32.9412 124.528 31.8269 123.748 30.3505C122.968 28.9019 122.606 27.2584 122.606 25.4477C122.606 23.6927 122.968 22.1048 123.692 20.6284C124.416 19.1798 125.419 18.0098 126.756 17.1184C128.066 16.2548 129.598 15.8091 131.353 15.8091C133.108 15.8091 134.668 16.1991 135.949 17.0069C137.259 17.7869 138.234 18.9012 138.93 20.2662C139.626 21.6591 139.961 23.2469 139.961 25.0298C139.961 25.3919 139.933 25.6984 139.849 25.9491H125.586C125.67 27.3141 125.976 28.4841 126.589 29.4034C127.174 30.3505 127.926 31.0469 128.846 31.5205C129.765 31.9941 130.712 32.2169 131.687 32.2169C133.999 32.2169 135.782 31.1305 137.036 28.9577L139.571 30.1834C138.791 31.6319 137.732 32.8019 136.395 33.6377C135.058 34.4734 133.442 34.9191 131.576 34.9191C129.876 35.0305 128.316 34.6127 126.951 33.7769ZM136.785 23.5255C136.729 22.7734 136.534 22.0212 136.144 21.2691C135.754 20.5169 135.169 19.8762 134.361 19.3469C133.554 18.8177 132.523 18.5669 131.297 18.5669C129.876 18.5669 128.679 19.0127 127.704 19.9319C126.729 20.8512 126.088 22.0491 125.781 23.5255H136.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.47 16.4219H146.34V19.3191H146.479C146.841 18.3162 147.51 17.5083 148.54 16.8398C149.543 16.1712 150.602 15.8369 151.716 15.8369C152.552 15.8369 153.248 15.9762 153.833 16.2269V19.4583C153.081 19.0683 152.218 18.9012 151.298 18.9012C150.435 18.9012 149.627 19.1519 148.903 19.6533C148.178 20.1548 147.593 20.8233 147.148 21.6591C146.702 22.4948 146.507 23.4141 146.507 24.3612V34.4733H143.498V16.4219H143.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.89282,
    y: 18.0063,
    width: 31.3277,
    height: 24.4208,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0631 20.0376H21.7056L10.0195 31.7265L16.6969 38.4038L35.0631 20.0376Z",
    fill: "#54C5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68014 28.3864L0 21.7063L21.7063 0H35.0638L6.68014 28.3864Z",
    fill: "#54C5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6975 38.4039L21.7062 43.4126H35.0637L23.3749 31.7266L16.6975 38.4039Z",
    fill: "#01579B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6975 38.4039L26.6035 34.9747L23.3749 31.7266L16.6975 38.4039Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6966 25.0456L10.019 31.7231L16.6966 38.4007L23.3741 31.7231L16.6966 25.0456Z",
    fill: "#29B6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0638 20.0376L23.3777 31.7237L35.0638 43.4126H21.7063L16.6976 38.4039L10.0174 31.7237L21.7063 20.0376H35.0638ZM21.7063 0L0 21.7063L6.68014 28.3864L35.0638 0H21.7063Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.6447,
    y1: 39.6934,
    x2: 23.6192,
    y2: 34.7189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153.833,
    height: 43.4126,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAABkCAYAAABO6zhfAAAACXBIWXMAAAx0AAAMdAH/P3aRAAAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterLogo);
export default __webpack_public_path__ + "static/media/flutterLogo.ec64036b4eacc9f3fd73f0e6751b7e6a.svg";
export { ForwardRef as ReactComponent };